import { USE_FEDERATION } from './config';
export function unwrap(data, scope) {
    return USE_FEDERATION ? data === null || data === void 0 ? void 0 : data[scope] : data;
}
export function wrap(data, scope) {
    return USE_FEDERATION ? { [scope]: data } : data;
}
